module.exports = __webpack_public_path__ + "static/media/22ESCWA19.45b19d6d.jpg";